export const filterPostulaciones = (postulaciones, filterConfig) => {
  let filtered = [...postulaciones];

  Object.entries(filterConfig).forEach(([question, criteria]) => {
    if (typeof criteria === "object") {
      // Filtro numérico
      filtered = filtered.filter((postulacion) => {
        const value =
          parseFloat(postulacion.respuestas_preguntas_licitador[question]) || 0;
        const min = criteria.min !== "" ? criteria.min : -Infinity;
        const max = criteria.max !== "" ? criteria.max : Infinity;
        return value >= min && value <= max;
      });
    } else {
      // Filtro Sí o No y Adjuntos
      if (criteria === "conArchivo") {
        filtered = filtered.filter(
          (postulacion) =>
            postulacion.respuestas_preguntas_licitador[question] !==
            "Sin documento adjunto"
        );
      } else if (criteria === "sinArchivo") {
        filtered = filtered.filter(
          (postulacion) =>
            postulacion.respuestas_preguntas_licitador[question] ===
            "Sin documento adjunto"
        );
      } else {
        filtered = filtered.filter(
          (postulacion) =>
            (
              postulacion.respuestas_preguntas_licitador[question] || ""
            ).toLowerCase() === criteria.toLowerCase()
        );
      }
    }
  });

  return filtered;
};

export const sortPostulaciones = (postulaciones, sortConfig) => {
  return [...postulaciones].sort((a, b) => {
    for (const { question, order, type } of sortConfig) {
      const aValue = a.respuestas_preguntas_licitador[question] || "";
      const bValue = b.respuestas_preguntas_licitador[question] || "";

      if (type === "number") {
        const aNum = parseFloat(aValue) || 0;
        const bNum = parseFloat(bValue) || 0;
        return order === "asc" ? aNum - bNum : bNum - aNum;
      }

      if (type === "yesno") {
        const mapValue = (v) => (v.toLowerCase() === "sí" ? 1 : 0);
        return order === "asc"
          ? mapValue(aValue) - mapValue(bValue)
          : mapValue(bValue) - mapValue(aValue);
      }

      if (type === "adjuntos") {
        const noTieneArchivo = (valor) => valor === "Sin documento adjunto";
        return order === "asc"
          ? !noTieneArchivo(bValue) - !noTieneArchivo(aValue)
          : !noTieneArchivo(aValue) - !noTieneArchivo(bValue);
      }
    }
    return 0;
  });
};
